export const spacing = {
  badge: {
    sm: "gap-1.5 px-2 py-0.5 text-xs leading-4",
    md: "gap-2 px-2.5 py-1 text-sm leading-5",
  },
  stack: {
    xs: "space-y-2",
    sm: "space-y-3",
    md: "space-y-4",
    lg: "space-y-6",
  },
  inline: {
    xs: "space-x-2",
    sm: "space-x-3",
    md: "space-x-4",
  },
  inset: {
    sm: "px-4 py-3",
    md: "p-4",
    lg: "p-6",
  },
  radius: {
    sm: "rounded-sm",
    md: "rounded-md",
    lg: "rounded-lg",
    xl: "rounded-xl",
    full: "rounded-full",
  },
};
